import React from 'react';
import { Spinner } from 'components/ui';
import classNames from 'classnames';

/**
 * 화면 중앙에 로딩 메시지를 표시하는 공통 컴포넌트
 * - 배경을 가리지 않아 작업 가능
 * - 메시지와 스피너를 함께 표시
 * - 선택적으로 진행 상황 표시 (예: "1/5")
 *
 * @param {Object} props
 * @param {boolean} props.loading - 표시 여부
 * @param {string} props.message - 표시할 메시지 (예: "저장 중...", "불러오는 중...")
 * @param {Object} [props.progress] - 진행 상황 (예: { current: 1, total: 5 })
 * @param {number} [props.progress.current] - 현재 진행 번호
 * @param {number} [props.progress.total] - 전체 개수
 * @param {string} [props.className] - 추가 CSS 클래스
 */
const CenterLoadingIndicator = ({ loading, message, progress, className }) => {
    if (!loading) return null;

    // 진행 상황 텍스트 생성 (total > 1인 경우에만 표시)
    const progressText = progress && progress.total > 1
        ? ` (${progress.current}/${progress.total})`
        : '';

    return (
        <div
            className={classNames(
                'fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50',
                'pointer-events-none',
                className
            )}
        >
            <div className="flex items-center gap-3 px-5 py-3 bg-gray-800 dark:bg-gray-700 text-white rounded-lg shadow-2xl">
                <Spinner size={24} color="white" isSpining={true} enableTheme={false} />
                <span className="text-base font-medium whitespace-nowrap">{message}{progressText}</span>
            </div>
        </div>
    );
};

export default CenterLoadingIndicator;
